// removed by extract-text-webpack-plugin
module.exports = {"container":"_2Ukr0K9itoUB5XfqZB4WBo"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Preview/styles.css
// module id = 2906
// module chunks = 0